import { render, staticRenderFns } from "./bottomMsg.vue?vue&type=template&id=2b8508bc&"
import script from "./bottomMsg.vue?vue&type=script&lang=js&"
export * from "./bottomMsg.vue?vue&type=script&lang=js&"
import style0 from "./bottomMsg.vue?vue&type=style&index=0&id=2b8508bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports